import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { DataContextProvider } from "./context/data-context";
import { AuthContextProvider } from "./context/auth-context";
import { UtilityContextProvider } from "./context/util-context";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AuthContextProvider>
    <BrowserRouter>
      <UtilityContextProvider>
        <DataContextProvider>
          <App />
        </DataContextProvider>
      </UtilityContextProvider>
    </BrowserRouter>
  </AuthContextProvider>
);
